import {
  createDraftOrder as publicCreateDraftOrder,
  createEmptyDraftOrder as publicCreateEmptyDraftOrder,
  addLineItemsToDraftOrder as publicAddLineItemsToDraftOrder,
  updateLineItems as publicUpdateLineItems,
  setDiscounts as publicSetDiscounts,
  createCustomDiscounts as publicCreateCustomDiscounts,
  deleteCustomDiscounts as publicDeleteCustomDiscounts,
  setAdditionalFees as publicSetAdditionalFees,
  createCustomAdditionalFees as publicCreateCustomAdditionalFees,
  deleteCustomAdditionalFees as publicDeleteCustomAdditionalFees,
  setShippingInfo as publicSetShippingInfo,
  setBuyerInfo as publicSetBuyerInfo,
  setRecipientInfo as publicSetRecipientInfo,
  setBillingInfo as publicSetBillingInfo,
  getDraftOrder as publicGetDraftOrder,
  getOrderDraftabilityStatus as publicGetOrderDraftabilityStatus,
  commitDraftOrder as publicCommitDraftOrder,
  createOrderFromDraft as publicCreateOrderFromDraft,
  deleteDraftOrder as publicDeleteDraftOrder,
  queryDraftOrders as publicQueryDraftOrders,
  setTaxExemption as publicSetTaxExemption,
  setBusinessLocation as publicSetBusinessLocation,
} from './ecom-v1-draft-order-draft-orders.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createDraftOrder: MaybeContext<
  BuildRESTFunction<typeof publicCreateDraftOrder> &
    typeof publicCreateDraftOrder
> = /*#__PURE__*/ createRESTModule(publicCreateDraftOrder);
export const createEmptyDraftOrder: MaybeContext<
  BuildRESTFunction<typeof publicCreateEmptyDraftOrder> &
    typeof publicCreateEmptyDraftOrder
> = /*#__PURE__*/ createRESTModule(publicCreateEmptyDraftOrder);
export const addLineItemsToDraftOrder: MaybeContext<
  BuildRESTFunction<typeof publicAddLineItemsToDraftOrder> &
    typeof publicAddLineItemsToDraftOrder
> = /*#__PURE__*/ createRESTModule(publicAddLineItemsToDraftOrder);
export const updateLineItems: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLineItems> & typeof publicUpdateLineItems
> = /*#__PURE__*/ createRESTModule(publicUpdateLineItems);
export const setDiscounts: MaybeContext<
  BuildRESTFunction<typeof publicSetDiscounts> & typeof publicSetDiscounts
> = /*#__PURE__*/ createRESTModule(publicSetDiscounts);
export const createCustomDiscounts: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomDiscounts> &
    typeof publicCreateCustomDiscounts
> = /*#__PURE__*/ createRESTModule(publicCreateCustomDiscounts);
export const deleteCustomDiscounts: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCustomDiscounts> &
    typeof publicDeleteCustomDiscounts
> = /*#__PURE__*/ createRESTModule(publicDeleteCustomDiscounts);
export const setAdditionalFees: MaybeContext<
  BuildRESTFunction<typeof publicSetAdditionalFees> &
    typeof publicSetAdditionalFees
> = /*#__PURE__*/ createRESTModule(publicSetAdditionalFees);
export const createCustomAdditionalFees: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomAdditionalFees> &
    typeof publicCreateCustomAdditionalFees
> = /*#__PURE__*/ createRESTModule(publicCreateCustomAdditionalFees);
export const deleteCustomAdditionalFees: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCustomAdditionalFees> &
    typeof publicDeleteCustomAdditionalFees
> = /*#__PURE__*/ createRESTModule(publicDeleteCustomAdditionalFees);
export const setShippingInfo: MaybeContext<
  BuildRESTFunction<typeof publicSetShippingInfo> & typeof publicSetShippingInfo
> = /*#__PURE__*/ createRESTModule(publicSetShippingInfo);
export const setBuyerInfo: MaybeContext<
  BuildRESTFunction<typeof publicSetBuyerInfo> & typeof publicSetBuyerInfo
> = /*#__PURE__*/ createRESTModule(publicSetBuyerInfo);
export const setRecipientInfo: MaybeContext<
  BuildRESTFunction<typeof publicSetRecipientInfo> &
    typeof publicSetRecipientInfo
> = /*#__PURE__*/ createRESTModule(publicSetRecipientInfo);
export const setBillingInfo: MaybeContext<
  BuildRESTFunction<typeof publicSetBillingInfo> & typeof publicSetBillingInfo
> = /*#__PURE__*/ createRESTModule(publicSetBillingInfo);
export const getDraftOrder: MaybeContext<
  BuildRESTFunction<typeof publicGetDraftOrder> & typeof publicGetDraftOrder
> = /*#__PURE__*/ createRESTModule(publicGetDraftOrder);
export const getOrderDraftabilityStatus: MaybeContext<
  BuildRESTFunction<typeof publicGetOrderDraftabilityStatus> &
    typeof publicGetOrderDraftabilityStatus
> = /*#__PURE__*/ createRESTModule(publicGetOrderDraftabilityStatus);
export const commitDraftOrder: MaybeContext<
  BuildRESTFunction<typeof publicCommitDraftOrder> &
    typeof publicCommitDraftOrder
> = /*#__PURE__*/ createRESTModule(publicCommitDraftOrder);
export const createOrderFromDraft: MaybeContext<
  BuildRESTFunction<typeof publicCreateOrderFromDraft> &
    typeof publicCreateOrderFromDraft
> = /*#__PURE__*/ createRESTModule(publicCreateOrderFromDraft);
export const deleteDraftOrder: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDraftOrder> &
    typeof publicDeleteDraftOrder
> = /*#__PURE__*/ createRESTModule(publicDeleteDraftOrder);
export const queryDraftOrders: MaybeContext<
  BuildRESTFunction<typeof publicQueryDraftOrders> &
    typeof publicQueryDraftOrders
> = /*#__PURE__*/ createRESTModule(publicQueryDraftOrders);
export const setTaxExemption: MaybeContext<
  BuildRESTFunction<typeof publicSetTaxExemption> & typeof publicSetTaxExemption
> = /*#__PURE__*/ createRESTModule(publicSetTaxExemption);
/** @internal */
export const setBusinessLocation: MaybeContext<
  BuildRESTFunction<typeof publicSetBusinessLocation> &
    typeof publicSetBusinessLocation
> = /*#__PURE__*/ createRESTModule(publicSetBusinessLocation);

export {
  DescriptionLineType,
  ItemTypeItemType,
  PaymentOptionType,
  JurisdictionType,
  SubscriptionFrequency,
  TaxableAddressType,
  VatType,
  PickupDetailsPickupMethod,
  SourceType,
  AppliedDiscountDiscountType,
  DiscountReason,
  EditingStatus,
  WeightUnit,
  PickupMethod,
  RuleType,
  FileType,
  DiscountType,
  NonDraftableReason,
  PaymentStatus,
  FulfillmentStatus,
  OrderStatus,
  LineItemQuantityChangeType,
  ActivityType,
  AttributionSource,
  ChannelType,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-draft-order-draft-orders.universal.js';
export {
  DraftOrder,
  ItemDetails,
  ItemDetailsChangeTypeOneOf,
  Price,
  PriceDescription,
  OrderLineItem,
  ProductName,
  CatalogReference,
  DescriptionLine,
  DescriptionLineValueOneOf,
  DescriptionLineDescriptionLineValueOneOf,
  DescriptionLineName,
  PlainTextValue,
  Color,
  FocalPoint,
  PhysicalProperties,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  ItemTaxFullDetails,
  LineItemTaxInfo,
  LineItemTaxBreakdown,
  DigitalFile,
  SubscriptionInfo,
  SubscriptionSettings,
  FreeTrialPeriod,
  LocationAndQuantity,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  ExtendedFields,
  ItemChangedDetails,
  ShippingDetails,
  ShippingDetailsChangeTypeOneOf,
  V1ShippingInformation,
  V1DeliveryLogistics,
  V1DeliveryLogisticsAddressOneOf,
  AddressWithContact,
  Address,
  StreetAddress,
  AddressLocation,
  FullAddressContactDetails,
  VatId,
  V1PickupDetails,
  PickupAddress,
  V1DeliveryTimeSlot,
  V1ShippingPrice,
  ShippingRegion,
  ShippingChangedDetails,
  BuyerInfo,
  BuyerInfoIdOneOf,
  AdditionalFeeDetails,
  AdditionalFee,
  TaxDetails,
  DiscountDetails,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  MerchantDiscountMerchantDiscountReasonOneOf,
  DiscountRule,
  DiscountRuleName,
  LineItemDiscount,
  CreatedBy,
  CreatedByStringOneOf,
  PriceSummary,
  TaxSummary,
  BalanceSummary,
  Balance,
  DraftOrderCommitSettings,
  InventoryUpdate,
  RecipientInfoDetails,
  RecipientInfoDetailsChangeTypeOneOf,
  RecipientInfoChangedDetails,
  OrderTaxInfo,
  OrderTaxBreakdown,
  BuyerDetails,
  BuyerDetailsChangeTypeOneOf,
  BuyerChangedDetails,
  BillingDetails,
  BillingDetailsChangeTypeOneOf,
  BillingChangedDetails,
  BusinessLocationDetails,
  BusinessLocationDetailsChangeTypeOneOf,
  Location,
  BusinessLocationChangedDetails,
  CreateDraftOrderRequest,
  CreateDraftOrderResponse,
  CalculatedDraftOrder,
  ShippingOption,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  ShippingPrice,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  CarrierErrors,
  CarrierError,
  CreateEmptyDraftOrderRequest,
  CreateEmptyDraftOrderResponse,
  AddLineItemsToDraftOrderRequest,
  CatalogReferenceLineItem,
  CustomLineItem,
  SecuredMedia,
  AddLineItemsToDraftOrderResponse,
  UpdateLineItemsRequest,
  LineItemChangeDetails,
  UpdateLineItemsResponse,
  SetDiscountsRequest,
  IdAndApplied,
  SetDiscountsResponse,
  CreateCustomDiscountsRequest,
  DiscountOption,
  DiscountOptionDiscountAmountOneOf,
  CreateCustomDiscountsResponse,
  DeleteCustomDiscountsRequest,
  DeleteCustomDiscountsResponse,
  SetAdditionalFeesRequest,
  SetAdditionalFeesResponse,
  CreateCustomAdditionalFeesRequest,
  AdditionalFeeOption,
  CreateCustomAdditionalFeesResponse,
  DeleteCustomAdditionalFeesRequest,
  DeleteCustomAdditionalFeesResponse,
  SetShippingInfoRequest,
  SetShippingInfoResponse,
  SetBuyerInfoRequest,
  SetBuyerInfoResponse,
  SetRecipientInfoRequest,
  SetRecipientInfoResponse,
  SetBillingInfoRequest,
  SetBillingInfoResponse,
  UpdateShippingInfoRequest,
  UpdateShippingInfoResponse,
  GetDraftOrderRequest,
  GetDraftOrderResponse,
  GetOrderDraftabilityStatusRequest,
  GetOrderDraftabilityStatusResponse,
  CommitDraftOrderRequest,
  CommitDraftOrderResponse,
  Order,
  Activity,
  ActivityContentOneOf,
  CustomActivity,
  MerchantComment,
  OrderRefunded,
  OrderCreatedFromExchange,
  NewExchangeOrderCreated,
  LineItemExchangeData,
  DraftOrderChangesApplied,
  OrderChange,
  OrderChangeValueOneOf,
  LineItemChanges,
  LineItemQuantityChange,
  LineItemPriceChange,
  ManagedLineItem,
  ManagedDiscount,
  TranslatedValue,
  LineItemAmount,
  ManagedAdditionalFee,
  TotalPriceChange,
  ShippingInformationChange,
  ShippingInformation,
  SavedPaymentMethod,
  AuthorizedPaymentCreated,
  AuthorizedPaymentCaptured,
  AuthorizedPaymentVoided,
  RefundInitiated,
  RefundedPayment,
  RefundedPaymentKindOneOf,
  RegularPaymentRefund,
  GiftCardPaymentRefund,
  MembershipPaymentRefund,
  PaymentRefunded,
  PaymentRefundFailed,
  RefundedAsStoreCredit,
  PaymentPending,
  PaymentPendingPaymentDetailsOneOf,
  RegularPayment,
  RegularPaymentPaymentMethodDetailsOneOf,
  CreditCardDetails,
  PaymentCanceled,
  PaymentCanceledPaymentDetailsOneOf,
  PaymentDeclined,
  PaymentDeclinedPaymentDetailsOneOf,
  ReceiptCreated,
  ReceiptCreatedReceiptInfoOneOf,
  WixReceipt,
  ExternalReceipt,
  ReceiptSent,
  ReceiptSentReceiptInfoOneOf,
  V1CreatedBy,
  V1CreatedByStringOneOf,
  ChannelInfo,
  CustomField,
  V1BalanceSummary,
  FulfillmentStatusesAggregate,
  Tags,
  TagList,
  CreateOrderFromDraftRequest,
  OrderCreateSettings,
  OrderCreateNotifications,
  CreateOrderFromDraftResponse,
  DeleteDraftOrderRequest,
  DeleteDraftOrderResponse,
  QueryDraftOrdersRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryDraftOrdersResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  SetTaxExemptionRequest,
  SetTaxExemptionResponse,
  GetDraftEditabilityStatusRequest,
  GetDraftEditabilityStatusResponse,
  SetBusinessLocationRequest,
  SetBusinessLocationResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  CreateDraftOrderResponseNonNullableFields,
  CreateEmptyDraftOrderResponseNonNullableFields,
  AddLineItemsToDraftOrderResponseNonNullableFields,
  UpdateLineItemsResponseNonNullableFields,
  SetDiscountsResponseNonNullableFields,
  CreateCustomDiscountsResponseNonNullableFields,
  DeleteCustomDiscountsResponseNonNullableFields,
  SetAdditionalFeesResponseNonNullableFields,
  CreateCustomAdditionalFeesResponseNonNullableFields,
  DeleteCustomAdditionalFeesResponseNonNullableFields,
  SetShippingInfoResponseNonNullableFields,
  SetBuyerInfoResponseNonNullableFields,
  SetRecipientInfoResponseNonNullableFields,
  SetBillingInfoResponseNonNullableFields,
  GetDraftOrderResponseNonNullableFields,
  GetOrderDraftabilityStatusResponseNonNullableFields,
  CommitDraftOrderResponseNonNullableFields,
  CreateOrderFromDraftResponseNonNullableFields,
  QueryDraftOrdersResponseNonNullableFields,
  SetTaxExemptionResponseNonNullableFields,
  SetBusinessLocationResponseNonNullableFields,
  AddLineItemsToDraftOrderOptions,
  UpdateLineItemsOptions,
  CreateCustomDiscountsOptions,
  CreateCustomAdditionalFeesOptions,
  CommitDraftOrderOptions,
  DraftOrdersQueryResult,
  DraftOrdersQueryBuilder,
} from './ecom-v1-draft-order-draft-orders.universal.js';
